export const pl = {
  translation: {
    common: {
      step1: "Krok 1",
      step2: "Krok 2",
      step3: "Krok 3",
      download: "Pobierz",
      downloadAgain: "Pobierz ponownie",
      downloadFileToSign: "Pobierz plik do podpisania",
      moveOn: "Przejdź",
      goAgain: "Przejdź ponownie",
      next: "Dalej",
      back: "Wstecz",
      add: "Dodaj",
      addSignedFile: "Dodaj podpisany plik",
      confirm: "Zatwierdź",
      skip: "Pomiń",
      taxNo: "NIP: {{taxNo}}",
      env: "Środowisko: {{env}}",
    },
    soleProprietorshipAlert: {
      title: "Dla jednoosobowej działalności gospodarczej",
      linkText: "Zobacz instrukcję",
    },
    copartnershipAlert: {
      title: "Dla spółek",
      description: "Aby poprawnie połączyć swoją spółkę z KSeF, wykonaj następujące kroki:",
      item1:
        "Jeśli nie masz pieczęci elektronicznej to złóż ZAW-FA do urzędu - jest to jednorazowe wskazanie administratora spółki w KSeF.",
      item2: "Zaloguj się do KSeF na stronie KSeF.",
      item3: "Jako administrator, nadaj sobie uprawnienia.",
      item4: "Połącz Scanye z KSeF.",
      linkText: "Zobacz instrukcję",
    },
    selectMethod: {
      title: "Połącz konto z KS<0>e</0>F",
      recommendedMethods: "Rekomendowane sposoby",
      otherMethods: "Pozostałe sposoby",
      environment: "Środowisko",
      production: "Produkcyjne",
      test: "Testowe",
      demo: "Demo",
      productionEnvironment: "Środowisko produkcyjne",
    },
    signedFlow: {
      completePreviousStepFirst: "Wykonaj najpierw poprzedni krok.",
      timerExplanation:
        "Od momentu pobrania pliku masz 10 minut na jego podpisanie i wgranie. Po upływie tego czasu sesja wygaśnie i konieczne będzie rozpoczęcie procesu od początku.",
      timerExpiredTitle: "Sesja wygasła",
      timerExpiredMessage:
        "Miałeś 10 minut na dokończenie procesu od momentu pobrania pliku. Czas minął — użyj przycisku poniżej lub strzałki wstecz, aby rozpocząć od nowa.",
      restartProcess: "Rozpocznij od nowa",
      restartShort: "Od nowa",
      uploadErrorTitle: "Błąd wgrywania pliku",
      uploadErrorMessage: "Nie udało się wysłać podpisanego pliku. Spróbuj ponownie lub rozpocznij proces od nowa.",
      timeRemaining: "Pozostały czas: {{time}}",
    },
    trustedProfileMethod: {
      shortTitle: "Profil zaufany",
      title: "Połącz z KS<0>e</0>F za pomocą Profilu Zaufanego",
      downloadFileToSign: "Pobierz plik do podpisania",
      goToYourTrustedProfileAndSign: "Przejdź do profilu zaufanego i podpisz",
      iAlreadyHaveSignedFile: "Mam plik już podpisany w Profilu Zaufanym (moj.gov.pl) - przejdź do wgrywania",
      step1Description:
        "Pobierz plik XML do podpisania. Plik zostanie wygenerowany przez system i zapisany na Twoim urządzeniu.",
      step2Description:
        "Otworzy się strona Profilu Zaufanego (moj.gov.pl). Zaloguj się i podpisz pobrany plik w usłudze.",
      step3Description:
        "Po podpisaniu pliku wróć tutaj i wgraj podpisany plik XML. Po wgraniu połączenie z KSeF zostanie dokończone.",
    },
    signatureMethod: {
      shortTitle: "Podpis kwalfikowany",
      title: "Połącz konto z KS<0>e</0>F za pomocą Podpisu kwalifikowanego",
      signFileInApp: "Podpisz pobrany plik w dedykowanej do tego aplikacji",
      step1Description:
        "Pobierz plik XML do podpisania. Plik zostanie wygenerowany przez system i zapisany na Twoim urządzeniu.",
      step2Description:
        "Otwórz pobrany plik w aplikacji do podpisu kwalifikowanego (np. Autenti, mObywatel, aplikacja certyfikatu) i podpisz go.",
      step3Description:
        "Po podpisaniu pliku wróć tutaj i wgraj podpisany plik XML. Po wgraniu połączenie z KSeF zostanie dokończone.",
    },
    tokenMethod: {
      shortTitle: "Token",
      title: "Połącz konto z KS<0>e</0>F za pomocą Tokenu",
      moveToKSef: "Przejdź do KSeF i wygeneruj token",
      description:
        "Token to Twój unikalny numer, który wygenerujesz na stronie KSeF. Z racji, że token generujesz raz, ze względów bezpieczeństwa nie rekomendujemy podawania ani publikowania tokenu.",
      addToken: "Dodaj token",
      confirmToken: "Zatwierdź",
      tokenHint: "Token to ciąg 64 znaków alfanumerycznych",
      tokenError: "Wystąpił błąd podczas komunikacji z serwerem",
      tokenTooLong: "Token może mieć maksymalnie 256 znaków",
    },
    certificateMethod: {
      shortTitle: "Certyfikat",
      title: "Połącz konto z KS<0>e</0>F za pomocą Certyfikatu",
      description: "Certyfikat należy wygenerować w KSeF, następnie wrócić do Scanye i wgrać plik tutaj.",
      moveToKSef: "Przejdź do KSeF i wygeneruj certyfikat",
      uploadFiles: "Wgraj certyfikat z KSeF",
      uploadFilesDescription: "Dodaj certyfikat, klucz prywatny i podaj hasło do klucza",
      seeInstruction: "Zobacz instrukcję",
      certFileHint: "Wgraj certyfikat (plik z rozszerzeniem.crt)",
      keyFileHint: "Wgraj klucz prywatny (plik z rozszerzeniem .key)",
      selectCert: "Wybierz plik certyfikatu uwierzytelniającego (.crt)",
      selectKey: "Wybierz plik klucza prywatnego (.key)",
      keyPassword: "Hasło do klucza",
      confirm: "Zaloguj",
      limitWarning:
        "Uwaga: pamiętaj o limitach certyfikatów KSeF — 4 certyfikaty dla osoby fizycznej, 100 dla spółki. Jeśli posiadasz już certyfikat, wgraj istniejące pliki zamiast generować nowe.",
      fileTooLarge: "Plik {{fileName}} jest zbyt duży. Maksymalny rozmiar to 10MB.",
      uploadError: "Wystąpił błąd podczas przesyłania plików. Sprawdź czy pliki są poprawne i spróbuj ponownie.",
      invalidFileType: "Nieprawidłowy typ pliku: {{fileName}}. Dozwolone rozszerzenia: {{validTypes}}",
    },
    upload: {
      dropHere: "Upuść plik tutaj",
      dragFileHereOr: "Przeciągnij tutaj lub",
      selectFromComputer: "wybierz z dysku",
      acceptedFormats: "Akceptowane formaty pliku: {{formats}}",
      invalidFileType: "Nieprawidłowy typ pliku: {{fileName}}. Dozwolone rozszerzenia: {{validTypes}}",
      fileTooLarge: "Plik {{fileName}} jest zbyt duży. Maksymalny rozmiar to 10MB.",
      uploadError: "Wystąpił błąd podczas przesyłania plików. Sprawdź czy pliki są poprawne i spróbuj ponownie.",
    },
    processing: {
      title: "Trwa nawiązywanie połączenia z KSeF",
      subtitle: "Możesz zamknąć to okno. Proces ten może\n trwać do 2 godzin i będzie kontynuowany w tle.",
      restart: "Rozpocznij od początku",
    },
    successPage: {
      title: "Konto zostało poprawnie połączone z KSeF",
      backToApp: "Wróć do aplikacji",
    },
    failPage: {
      title: "Nie udało się powiązać konta z KSeF",
      restart: "Rozpocznij od początku",
    },
    missingIntegrationId: {
      title: "Nie odnaleziono identyfikatora sesji",
      description: "Sprawdź czy w parametrach URL znajduje się identyfikator sesji i spróbuj ponownie.",
      setToken: "Jeśli znasz identyfikator sesji, możesz go wprowadzić ręcznie:",
      integrationId: "Identyfikator integracji",
      confirmId: "Wprowadź ID",
    },
    error: {
      title: "Wystąpił błąd",
      description: "Spróbuj ponownie później.",
      refresh: "Odśwież aplikację",
      details: "Szczegóły błędu",
      AuthenticationFailed: {
        description:
          "Wystąpił błąd autoryzacji. Sprawdź uprawnienia w Aplikacji Podatnika. Usuń integrację i spróbuj ponownie.",
      },
      AuthenticationTimeout: {
        description:
          "Przekroczono limit czasu uwierzytelnienia, spróbuj ponownie. Możliwą przyczyną są problemy z samym KSeF.",
      },
      Forbidden: {
        description: "Brak dostępu. Nie masz uprawnień do tej operacji. Sprawdź uprawnienia w Aplikacji Podatnika.",
      },
      InvalidToken: {
        description: "Nieprawidłowy token. Wygeneruj nowy token w portalu KSeF i skonfiguruj integrację ponownie.",
      },
      NoAuthorization: {
        description: "Brak autoryzacji. Sprawdź uprawnienia w Aplikacji Podatnika. Usuń integrację i spróbuj ponownie.",
      },
      SessionSignedRequestTimeout: {
        description: "Przekroczono limit czasu sesji, spróbuj ponownie. Limit czasu sesji wynosi 10 min.",
      },
      TokenInactive: {
        description: "Token nieaktywny. Aktywuj token w portalu KSeF lub skonfiguruj integrację ponownie.",
      },
      TokenNotFound: {
        description: "Nie znaleziono tokenu. Skonfiguruj integrację ponownie.",
      },
      TokenRevoked: {
        description: "Token unieważniony. Wygeneruj nowy token w portalu KSeF i skonfiguruj integrację ponownie.",
      },
      Unauthorized: {
        description: "Błąd autoryzacji. Sprawdź uprawnienia w Aplikacji Podatnika. Usuń integrację i spróbuj ponownie.",
      },
      UnknownError: {
        description: "Wystąpił nieznany błąd. Usuń integrację i spróbuj ponownie.",
      },
      WebhookDeliveryFailed: {
        description: "Nie udało się dostarczyć powiadomienia. Usuń integrację i spróbuj ponownie.",
      },
    },
  },
};
